/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/anchor-is-valid */

import TestVideoPlayer from "../AssessmentTimer/TestVideoPlayer";
import obliques from "../../images/obliques-m.PNG";
const classNames = require("classnames");

export default function ExerciseVideoPlayer({
  showExercise,
  playing,
  counter,
  showCounter,
}) {
  // Check if we need to flip the video orientation
  // If the video orientation is already flipped, we need to flip
  const isFlipVideo = showExercise.exerciseLevel.video_flip != (showExercise.is_flip_orientation || showExercise.position === 2);

  const isFlipFeelIt = showExercise.position === 2 || showExercise.is_flip_orientation;

  function getPosition(position) {
    if (position === "TR") {
      return "top-right";
    } else if (position === "TL") {
      return "top-left";
    } else if (position === "BL") {
      return "bottom-left";
    } else if (position === "BR") {
      return "bottom-right";
    } else {
      return "";
    }
  }

  function getOrientationText(orientation) {
    if (orientation === 1) {
      return "Left Side Only";
    }
    if (orientation === 2) {
      return "Right Side Only";
    }

    if (orientation === 3) {
      if (showExercise.is_flip_orientation) {
        return "Right Side";
      } else {
        return "Left Side";
      }
    }

    return "";
  }

  return (
    <div
      className="ssa box_video"
      style={{ textAlign: "center" }}
      data-click="0"
    >
      <TestVideoPlayer
        playing={playing}
        videoUrl={
          showExercise.exerciseLevel.video +
          "#t=" +
          showExercise.exerciseLevel.video_start_time +
          "," +
          showExercise.exerciseLevel.video_end_time
        }
        posterUrl={showExercise.exerciseLevel.video_cover}
        className={classNames({
          video: true,
          "flip-video": isFlipVideo,
        })}
        showExercise={showExercise}
      />
      {showCounter && <a className="timer">{counter}</a>}
      {showExercise.feel_it_show === 1 ? (
        <img
          className={classNames({
            "img-fluid": true,
            "feel-it-here": true,
            [getPosition(showExercise.feel_it_position)]: true,
            "flip-video": isFlipFeelIt,
          })}
          crossOrigin="anonymous"
          src={
            showExercise?.exerciseLevel?.body_part
              ? showExercise?.exerciseLevel?.body_part?.male_image
              : obliques
          }
          alt={"Feel IT"}
          title={"Feel It Here Image"}
        />
      ) : (
        ""
      )}
      {showExercise.text_show === 1 ? (
        <p
          className={classNames({
            "text-placement": true,
            [getPosition(showExercise.text_position)]: true,
          })}
        >
          {getOrientationText(showExercise.position)}
        </p>
      ) : (
        ""
      )}
    </div>
  );
}
